<template>

<v-app>
  <div class="back">
    <Navbar />
    <v-main>
      <router-view></router-view>
    </v-main>
    <Footer />
  </div>
</v-app>

</template>

<script>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: "App",
  components: {
    Navbar,
    Footer
  },
  data() { 
    return {

    }
  }
}

</script>

<style>
.back { 
  background-color: #F1F8E9;
  height: 100vh;
}
</style>
